import { Component } from "react";

import {
  Container,
  Title,
  Number,
  ButtonsWrapper,
  StyledButton,
} from "./Count.styled.js";

export class Count extends Component {
  state = {
    count: 0,
  };

  componentDidMount() {
    console.log("Компонент додали до DOM");
  }

  componentDidUpdate(previousProps, previousState) {
    // if (previousState.count !== this.state.count) {
    //   console.log("Змінився count");
    // }

    console.log("Компонент був оновлений");
    console.log("Було -", previousState);
    console.log("Стало -", this.state);
  }

  componentWillUnmount() {
    console.log("Компонент видалено");
  }

  incrementCounter = () => {
    this.setState((previousState) => ({
      count: previousState.count + 1,
    }));
  };

  decrementCounter = () => {
    this.setState((previousState) => ({
      count: previousState.count - 1,
    }));
  };

  render() {
    return (
      <Container>
        <Title>Лічильник</Title>
        <Number>{this.state.count}</Number>
        <ButtonsWrapper>
          <StyledButton type="decrement" onClick={this.decrementCounter}>
            -
          </StyledButton>
          <StyledButton type="increment" onClick={this.incrementCounter}>
            +
          </StyledButton>
        </ButtonsWrapper>
      </Container>
    );
  }
}
